import { SettingsSection } from '@components'

import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useInvoiceSettingsForm } from '../../../../contexts/invoiceSettingsFormContext'

export const InvoiceSettingsFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { isLoading, isSubmitting, submitForm } = useInvoiceSettingsForm()

  const handleSaveButtonClick = useCallback(() => {
    trackInvoicingSettings('Save changes clicked')
    submitForm()
  }, [submitForm, trackInvoicingSettings])

  return (
    <SettingsSection.Footer>
      <Button disabled={isLoading || isSubmitting} loading={isSubmitting} onClick={handleSaveButtonClick}>
        {t('settings.organization.external_invoice.footer.save_changes')}
      </Button>
    </SettingsSection.Footer>
  )
}
